(function(){
  var root=document.getElementById('bw-home'); if(!root) return;
  var reduce=window.matchMedia&&matchMedia('(prefers-reduced-motion: reduce)').matches;
  if(!reduce) root.classList.add('js');
  var $=function(s,c){return (c||root).querySelector(s);}, $$=function(s,c){return [].slice.call((c||root).querySelectorAll(s));};
  var vh=function(){return window.innerHeight||document.documentElement.clientHeight;};
  var portrait=function(){return window.matchMedia&&matchMedia('(orientation: portrait)').matches;};
  var deskPin=function(){return !reduce&&window.matchMedia&&matchMedia('(min-width:1000px) and (hover:hover)').matches;};

  /* ---- video: right crop for the screen, play only while visible (muted + playsinline for iPhone) ---- */
  var vids=$$('video[data-wide]');
  vids.forEach(function(v){
    var tall=portrait(), src=tall?v.getAttribute('data-tall'):v.getAttribute('data-wide');
    if(tall&&v.getAttribute('data-poster-tall')) v.setAttribute('poster',v.getAttribute('data-poster-tall'));
    if(src&&v.getAttribute('src')!==src) v.setAttribute('src',src);
    v.muted=true; v.setAttribute('muted','');
    if(reduce){v.removeAttribute('autoplay');v.pause();}
  });
  if('IntersectionObserver' in window && !reduce){
    var vio=new IntersectionObserver(function(es){es.forEach(function(e){var v=e.target;
      if(e.isIntersecting){if(v.preload==='none')v.preload='auto';var p=v.play();if(p&&p.catch)p.catch(function(){});}else{v.pause();}});},{rootMargin:'200px 0px'});
    vids.forEach(function(v){vio.observe(v);});
  }

  /* ---- menu (phones/tablets) ---- */
  var mbtn=$('[data-menu-btn]'), menu=$('[data-menu]');
  function setMenu(open){if(!menu)return;menu.hidden=!open;mbtn.setAttribute('aria-expanded',open?'true':'false');document.documentElement.style.overflow=open?'hidden':'';}
  if(mbtn){mbtn.addEventListener('click',function(){setMenu(menu.hidden);});
    $$('a',menu).forEach(function(a){a.addEventListener('click',function(){setMenu(false);});});
    document.addEventListener('keydown',function(e){if(e.key==='Escape'&&!menu.hidden)setMenu(false);});}

  /* ---- services row: scrolling moves the row sideways on desktop; native swipe on touch ---- */
  var hs=$('[data-hscroll]'), track=$('[data-htrack]'), viewport=$('[data-hviewport]'), hbar=$('[data-hbar]'), dist=0;
  function measure(){
    if(!hs) return;
    if(deskPin()){
      var g=parseFloat(getComputedStyle(viewport).paddingLeft)||0;
      dist=Math.max(0,track.scrollWidth-(viewport.clientWidth-2*g));
      hs.style.setProperty('--hlen',(vh()+dist*1.15)+'px');
    } else { hs.style.removeProperty('--hlen'); hs.style.setProperty('--hx',0); }
  }
  if(viewport) viewport.addEventListener('scroll',function(){
    if(deskPin()) return; var m=viewport.scrollWidth-viewport.clientWidth; hs.style.setProperty('--hp',m>0?(viewport.scrollLeft/m).toFixed(3):0);},{passive:true});
  function goToCard(i){
    var card=track&&track.children[i]; if(!card) return;
    if(deskPin()){
      var p=Math.min(1,(card.offsetLeft)/(dist||1)); var top=hs.getBoundingClientRect().top+window.scrollY;
      window.scrollTo({top:top+p*(hs.offsetHeight-vh()),behavior:'smooth'});
    } else {
      hs.scrollIntoView({behavior:reduce?'auto':'smooth'});
      setTimeout(function(){viewport.scrollTo({left:card.offsetLeft-(parseFloat(getComputedStyle(viewport).paddingLeft)||0),behavior:'smooth'});},reduce?0:350);
    }
  }
  $$('[data-jump]').forEach(function(a){a.addEventListener('click',function(e){e.preventDefault();goToCard(parseInt(a.getAttribute('data-jump'),10));});});

  /* tap to expand a service card (hover does it on desktop) */
  $$('[data-toggle]').forEach(function(b){b.addEventListener('click',function(){
    var card=b.closest('.bw-card'), open=!card.classList.contains('is-open');
    card.classList.toggle('is-open',open); b.setAttribute('aria-expanded',open?'true':'false');});});

  /* ---- scroll-driven bits ---- */
  var scenes=$$('[data-scene]'), par=$$('.bw-nash,.bw-hands');
  var navLinks=$$('[data-spy-nav] a'), spyTargets=navLinks.map(function(a){return document.querySelector(a.getAttribute('href'));});
  var ticking=false;
  function update(){
    ticking=false; var h=vh();
    scenes.forEach(function(sc){var r=sc.getBoundingClientRect(),span=Math.max(1,r.height-h),p=reduce?0.9:Math.min(1,Math.max(0,-r.top/span));
      sc.style.setProperty('--p',p.toFixed(4)); sc.classList.toggle('is-asking',p>0.74);});
    if(hs&&deskPin()){var r=hs.getBoundingClientRect(),span=Math.max(1,r.height-h),p=Math.min(1,Math.max(0,-r.top/span));
      hs.style.setProperty('--hx',(p*dist).toFixed(1)); hs.style.setProperty('--hp',p.toFixed(3));}
    par.forEach(function(el){var r=el.getBoundingClientRect();el.style.setProperty('--vp',Math.min(1,Math.max(0,(h-r.top)/(h+r.height))).toFixed(3));});
    var top=$('[data-bw-top]'); if(top) top.classList.toggle('is-solid',window.scrollY>40);
    var cur=-1; spyTargets.forEach(function(t,i){if(t&&t.getBoundingClientRect().top<h*0.4)cur=i;});
    navLinks.forEach(function(a,i){a.setAttribute('aria-current',i===cur?'true':'false');});
    stickyUpdate();
  }
  function onScroll(){if(!ticking){ticking=true;requestAnimationFrame(update);}}
  window.addEventListener('scroll',onScroll,{passive:true});
  window.addEventListener('resize',function(){measure();onScroll();});
  window.addEventListener('load',function(){measure();update();});
  measure(); update();

  /* ---- "Is this you?" ---- */
  var you=$('[data-you]');
  if(you){var qs=$$('.bw-you-q',you);
    var act=function(q){qs.forEach(function(o){var on=o===q;o.classList.toggle('is-on',on);var p=document.getElementById(o.getAttribute('data-panel'));if(p)p.hidden=!on;});};
    qs.forEach(function(q){q.addEventListener('mouseenter',function(){act(q);});q.addEventListener('focus',function(){act(q);});});}

  /* ---- FAQ topics ---- */
  var faq=$('.bw-faq'), tabs=$('[data-faq-tabs]');
  if(faq&&tabs&&!reduce){
    tabs.hidden=false; faq.classList.add('is-tabbed');
    var groups=$$('[data-faq-group]',faq), tbs=$$('[data-faq-tab]',tabs);
    var show=function(i){groups.forEach(function(g,k){g.hidden=k!==i;});tbs.forEach(function(b,k){b.setAttribute('aria-selected',k===i?'true':'false');b.tabIndex=k===i?0:-1;});};
    tbs.forEach(function(b,k){b.addEventListener('click',function(){show(k);});
      b.addEventListener('keydown',function(e){var n=e.key==='ArrowRight'?k+1:e.key==='ArrowLeft'?k-1:null;if(n===null)return;n=(n+tbs.length)%tbs.length;tbs[n].focus();show(n);});});
    show(0);
    /* a link to a question in another topic still works */
    $$('a[href^="#"]',faq).forEach(function(a){a.addEventListener('click',function(){var t=document.querySelector(a.getAttribute('href'));if(t&&!faq.contains(t))return;});});
  }

  /* ---- detail drawer ---- */
  var drawer=$('[data-drawer]'), lastFocus=null;
  function openDrawer(key){
    if(!drawer||!$('[data-detail="'+key+'"]',drawer)) return; lastFocus=document.activeElement;
    $$('[data-detail]',drawer).forEach(function(d){var on=d.getAttribute('data-detail')===key;d.hidden=!on;var t=$('[data-title]',d);if(t)t.id=on?'bw-drawer-title':'';});
    drawer.classList.add('is-open'); document.documentElement.style.overflow='hidden';
    var c=$('.bw-drawer-close',drawer); setTimeout(function(){c&&c.focus();},60);
  }
  function closeDrawer(){
    if(!drawer||!drawer.classList.contains('is-open')) return;
    drawer.classList.remove('is-open'); document.documentElement.style.overflow='';
    if(lastFocus&&lastFocus.focus) lastFocus.focus({preventScroll:true});
  }
  $$('[data-open]').forEach(function(b){b.addEventListener('click',function(){openDrawer(b.getAttribute('data-open'));});});
  if(drawer){
    $$('[data-close]',drawer).forEach(function(b){b.addEventListener('click',closeDrawer);});
    drawer.addEventListener('keydown',function(e){
      if(e.key==='Escape'){closeDrawer();}
      if(e.key==='Tab'){var f=$$('a[href],button:not([disabled])',drawer).filter(function(x){return x.offsetParent!==null;});
        if(!f.length) return; var first=f[0],last=f[f.length-1];
        if(e.shiftKey&&document.activeElement===first){e.preventDefault();last.focus();}
        else if(!e.shiftKey&&document.activeElement===last){e.preventDefault();first.focus();}}
    });
  }
  /* Explore: service page once it exists; until then the link points at #detail-KEY and opens the panel */
  $$('[data-detail-key]').forEach(function(a){a.addEventListener('click',function(e){
    var h=a.getAttribute('href')||''; if(h.indexOf('#detail-')===0){e.preventDefault();openDrawer(a.getAttribute('data-detail-key'));}});});
  $$('.bw-d-actions a.bw-btn--line').forEach(function(a){if((a.getAttribute('href')||'').indexOf('#detail-')===0)a.hidden=true;});
  if(location.hash.indexOf('#detail-')===0){openDrawer(location.hash.slice(8));}

  /* pick a service: prefill the form */
  var sel=$('[data-svc-select]');
  $$('[data-pick]').forEach(function(a){a.addEventListener('click',function(e){
    var v=a.getAttribute('data-pick');
    if(sel){[].forEach.call(sel.options,function(o){if(o.text.toLowerCase()===v.toLowerCase())sel.value=o.value||o.text;});}
    if(a.hasAttribute('data-close-after')){e.preventDefault();closeDrawer();var t=$('#start');setTimeout(function(){t&&t.scrollIntoView({behavior:reduce?'auto':'smooth'});},80);}
  });});

  /* ---- reveal on view ---- */
  if('IntersectionObserver' in window && !reduce){
    var rio=new IntersectionObserver(function(es){es.forEach(function(e){if(e.isIntersecting){e.target.classList.add('is-in');rio.unobserve(e.target);}});},{rootMargin:'0px 0px -10% 0px'});
    $$('.bw-reveal').forEach(function(el){rio.observe(el);});
  } else {$$('.bw-reveal').forEach(function(el){el.classList.add('is-in');});}

  /* ---- sticky mobile CTA ---- */
  var bar=$('[data-bw-sticky]'), light=$('.bw-light'), fin=$('#start');
  function inView(el,pad){if(!el)return false;var r=el.getBoundingClientRect();return r.top<vh()*(1-(pad||0))&&r.bottom>vh()*(pad||0);}
  function pinned(sc){if(!sc)return false;var r=sc.getBoundingClientRect();return r.top<=1&&r.bottom>=vh()-1;}
  function stickyUpdate(){
    if(!bar) return;
    var on=window.scrollY>vh()*0.85 && !inView(fin,0.12) && !pinned(light) && !(drawer&&drawer.classList.contains('is-open'));
    bar.classList.toggle('is-on',on); bar.setAttribute('aria-hidden',on?'false':'true');
    var a=$('a',bar); if(a) a.tabIndex=on?0:-1;
  }

  /* preview-only demo form */
  var demo=$('[data-bw-demo]');
  if(demo) demo.addEventListener('submit',function(e){e.preventDefault();
    if(demo.checkValidity&&!demo.checkValidity()){demo.reportValidity&&demo.reportValidity();return;}
    var ok=$('[data-bw-ok]',demo);ok.hidden=false;ok.setAttribute('tabindex','-1');ok.focus();});
})();
